export default {"src":"/_next/static/media/download-blue.13e75bb8.svg","height":20,"width":20};